<template>
  <footer class="xs-footer-section footer-group"
          style="background-image: url('../assets/images/footer-bg.png')">
    <div class="footer-main">
      <div class="container">
        <div class="row">
          <div class="col-md-3">
            <div class="footer-widget wow fadeInUp"><h3 class="widget-title">Services</h3>
              <div class="menu-services-container">
                <ul id="menu-services" class="menu">
                  <li id="menu-item-1370"
                      class="menu-item menu-item-type-post_type menu-item-object-page menu-item-1370">
                    <router-link :to="{ path: 'shared-hosting' }">Shared Hosting </router-link>
                  </li>
                  <li id="menu-item-1369"
                      class="menu-item menu-item-type-post_type menu-item-object-page menu-item-1369">
                    <router-link :to="{ path: 'reseller-hosting' }">Reseller Hosting</router-link>
                  </li>
                  <li id="menu-item-1367"
                      class="menu-item menu-item-type-post_type menu-item-object-page menu-item-1367">
                    <router-link :to="{ path: 'cloud-hosting' }">Cloud Hosting</router-link>
                  </li>
                  <li id="menu-item-1368"
                      class="menu-item menu-item-type-post_type menu-item-object-page menu-item-1368">
                    <router-link :to="{ path: 'vps-hosting' }">VPS Hosting</router-link>
                   </li>
                  <li id="menu-item-1366"
                      class="menu-item menu-item-type-post_type menu-item-object-page menu-item-1366">
                    <router-link :to="{ path: 'dedicated-hosting' }">Dedicated Hosting</router-link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="col-md-3">
            <div class="footer-widget wow fadeInUp"><h3 class="widget-title">Công ty</h3>
              <div class="menu-company-container">
                <ul id="menu-company" class="menu">
                  <li id="menu-item-692"
                      class="menu-item menu-item-type-post_type menu-item-object-page menu-item-692">
                    <router-link :to="{ path: 'about' }">About Us</router-link>
                  </li>
                  <li id="menu-item-699"
                      class="menu-item menu-item-type-post_type menu-item-object-page menu-item-699">
                    <router-link :to="{ path: 'contact' }">Contact</router-link>
                  </li>
                  <li id="menu-item-696"
                      class="menu-item menu-item-type-post_type menu-item-object-page menu-item-696">
                    <router-link :to="{ path: 'support' }">Support</router-link>
                  </li>
                  <!-- <li id="menu-item-695"
                      class="menu-item menu-item-type-post_type menu-item-object-page menu-item-695">
                    <router-link :to="{ path: 'pricing' }">Pricing</router-link>
                  </li>
                  <li id="menu-item-693"
                      class="menu-item menu-item-type-post_type menu-item-object-page menu-item-693">
                    <router-link :to="{ path: 'affiliate' }">Affiliate</router-link>
                  </li> -->
                </ul>
              </div>
            </div>
          </div>
          <div class="col-md-3">
            <div class="footer-widget wow fadeInUp"><h3 class="widget-title">Solutions</h3>
              <div class="menu-solutions-container">
                <ul id="menu-solutions" class="menu">
                  <li id="menu-item-704"
                      class="menu-item menu-item-type-post_type menu-item-object-page menu-item-704">
                    <router-link :to="{ path: 'whois' }">Chính sách thanh toán</router-link>
                  </li>
                  <li id="menu-item-705"
                      class="menu-item menu-item-type-post_type menu-item-object-page menu-item-705">
                    <router-link :to="{ path: 'terms' }">Điều khoản dịch vụ</router-link>
                  </li>
                  <li id="menu-item-703"
                      class="menu-item menu-item-type-post_type menu-item-object-page menu-item-703">
                    <router-link :to="{ path: 'privacy' }">Chính sách bảo mật</router-link>
                  </li>
                  <li id="menu-item-701"
                      class="menu-item menu-item-type-post_type menu-item-object-page menu-item-701">
                    <router-link :to="{ path: 'faq' }">Chính sách khiếu nại</router-link>
                   </li>
                  <li id="menu-item-702"
                      class="menu-item menu-item-type-post_type menu-item-object-page menu-item-702">
                    <a href="https://dash.episcloud.com/login/">Log In</a></li>
                </ul>
              </div>
            </div>
          </div>
          <div class="col-md-3">
            <div class="footer-widget wow fadeInUp"><h3 class="widget-title">Address</h3>
              <div class="textwidget">
                <ul class="contact-info-widget">
                  <li class="media" style="color: white;text-align: left"> 16 East 34th Street,New York, NY 10016.</li>
                  <li class="media"  style="color: white;text-align: left"> 428, Seolleung-ro, Gangnam-gu, Seoul 06192.</li>
                  <li class="media" style="color: white;text-align: left"> 9 Battery Road, Singapore, 049910.</li>
                  <li class="media" style="color: white;text-align: left"> 1 Sussex Street, Barangaroo,Sydney, NSW 2000.</li>
                  <li class="media" style="color: white;text-align: left"> 401 Collins Street, Melbourne, VIC 3000.</li>
                  <li class="media" style="color: white;text-align: left"> 273 Phú Thọ Hòa, Phường Phú Thọ Hoà, Quận Tân Phú, Thành phố Hồ Chí Minh.</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="footer-bottom">
        <div class="row">
          <div class="col-md-6">
            <div class="footer-bottom-info wow fadeInUp">
              
            </div>
          </div>
          <div class="col-md-6">
            <ul class="xs-list list-inline wow fadeInUp">
              <li><img src="../assets/images/security-company-images-2.png" alt="">
              </li>
              <li><img src="../assets/images/security-company-images-3.png" alt="">
              </li>
              <li><img src="../assets/images/security-company-images-1.png" alt="">
              </li>
              <li><img src="../assets/images/security-company-images-4.png" alt="">
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="footer-copyright">
      <div class="container">
        <div class="row">
          <div class="col-md-4">
            <div class="copyright-text copyright-text-style-2 wow fadeInUp">
              <p>© 2022 <a href="episcloud.vn">EPISCloud.VN </a></p>
              <p> Trang Website được quản lý bởi Công Ty TNHH EPIS Việt Nam</p>
              <p> Địa chỉ: 273 Phú Thọ Hòa, Phường Phú Thọ Hoà, Quận Tân Phú, Thành phố Hồ Chí Minh.</p>
              <p> GPKD số 0316494549 do Sở KH và ĐT TP Hồ Chí Minh cấp.</p>
            </div><!-- .copyright-text END -->
          </div>

          <div class="col-md-4">
            <div class="footer-logo-wraper wow fadeInUp" data-wow-duration="1s">
              <a href="https://episcloud.com/" class="footer-logo"><img
                style="width: 50%;"
                src="../assets/images/facebook_cover_photo_1-removebg-preview.png"
                alt="footer logo"></a>
            </div>
            <!-- .footer-logo-wraper END -->
          </div>
          <div class="col-md-4">
            <div class="social-list-wraper wow fadeInUp" data-wow-duration="1.3s">
              <ul class="social-list">
                <li><a href="https://www.facebook.com/epis.cloud"><i class="fa fa-facebook"></i></a></li>
               
              </ul>
            </div><!-- .social-list-wraper END -->
          </div>
        </div><!-- .row END -->
      </div><!-- .container END -->
    </div><!-- .footer-copyright END -->

  </footer>
</template>

<script>
export default {
  name: 'Footer'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Footer.vue